import icon from '../../../icon'
import tfriLogo from '../../../assets/major_logo.svg'
import yfyLogo from '../../../assets/cropped-yfy_logo.png'
import yfyLogoOnly from '../../../assets/YFY_logo_only.svg.webp'
import React from 'react'
import './CreditDialogContent.scss'

export interface ICreditDialogContentProps {
  description: string
  herf?: string
}

const CreditDialogContent: React.FC<ICreditDialogContentProps> = ({
  description,
  herf,
}: ICreditDialogContentProps) => {
  return (
    <div className="dui-CreditDialogContent">
      <div className="dui-CreditDialogContent-content">
        <span dangerouslySetInnerHTML={{ __html: description }}></span>
        <img className="qr-code" src={icon.credit.qrcode} alt="qrcode" />
      </div>
      <div className="final">
        <a
          href="https://www.tfri.gov.tw/Default.aspx"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={tfriLogo} alt="林業試驗所 logo" />
        </a>
        <a
          href="https://www.yfycpg.com/zh-TW"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="YFY-logo">
            <img className="YFY-logo-only" src={yfyLogoOnly} alt="YFY logo" />
            <img className="YFY-logo-text" src={yfyLogo} alt="YFY logo" />
          </div>
        </a>
        <a href={herf} target="_blank" rel="noopener noreferrer">
          <img src={icon.credit.logo} alt="jsdc-logo" />
        </a>
      </div>
    </div>
  )
}
CreditDialogContent.displayName = 'CreditDialogContent'
export default CreditDialogContent
